// extracted by mini-css-extract-plugin
export default {"vehicleGroupPanel":"CompanyPlatoonGroupPanel_vehicleGroupPanel__iavS4","accordions":"CompanyPlatoonGroupPanel_accordions__aTsQb"};